export default "__VITE_ASSET__DdAh50OH__"